import { Alert, Stack, Table, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { PublicationInfluence as MetricsType } from '@/module/Journal';

import { formatDecimal } from '@feature/utils';

export interface PublicationInfluenceProps {
  data: MetricsType;
  hideTemporary?: boolean;
}

export function PublicationInfluence({ data, hideTemporary }: PublicationInfluenceProps) {
  const { metrics, journal, rank, temporary } = data;
  const { t } = useTranslation();

  if (journal == null) {
    return (
      <Text
        c="dimmed"
        fs="italic"
      >
        {t('journals.influence.missingParams')}
      </Text>
    );
  }

  if (metrics == null) {
    return (
      <Text
        c="dimmed"
        fs="italic"
      >
        {t('journals.influence.noMetrics')}
      </Text>
    );
  }

  return (
    <Stack>
      {!hideTemporary && temporary && (
        <Alert
          color="yellow"
          title={t('journals.influence.temporary.title')}
          icon={<IconInfoCircle />}
        >
          {t('journals.influence.temporary.content')}
        </Alert>
      )}
      {rank != null && (
        <Text>{`Cea mai bună încadrare este pentru anul ${rank.year}, categoria ${rank.wosCategory?.name}, index ${rank.wosIndex?.name} in ${rank.quarterly}, rank ${rank.rank} din ${rank.rankOf}`}</Text>
      )}
      <Table
        variant="vertical"
        layout="fixed"
        withTableBorder
        bg="white"
      >
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w={350}>{journal.wosId ?? journal.title}</Table.Th>
            <Table.Td fw="500">{metrics.year}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>{t('journals.influence.ais')}</Table.Th>
            <Table.Td>{formatDecimal(metrics.articleInfluenceScore)}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
